// © 2015-2021 WDNA - All Rights Reserved

import api, { AxiosRequestConfig } from '../../../services/api/Connect';

export * from './types';

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function alarm<T = any>(action: string, id?: string, data?: any, options?: AxiosRequestConfig): Promise<T> | undefined {
  const root: string = 'alarm';
  switch (action) {
    case 'list':
      return api.post(`${root}/list`, data, options);
    case 'get':
      return id ? api.get(`${root}/get/${id}`, data, options) : undefined;
    case 'set':
      return api.put(`${root}/set`, data, options);
    case 'del':
      return id ? api.delete(`${root}/del/${id}`, data, options) : undefined;
    case 'status':
      return api.post(`${root}/status`, data, options);
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function notice<T = any>(action: string, id?: string, data?: any, options?: AxiosRequestConfig): Promise<T> | undefined {
  const root: string = 'notice';
  switch (action) {
    case 'list':
      return api.post(`${root}/list`, data, options);
    case 'get':
      return id ? api.get(`${root}/get/${id}`, data, options) : undefined;
    case 'del':
      return id ? api.delete(`${root}/del/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}
